import {
	DocumentItemViewModel,
	FileViewModel,
	DocumentItemType
} from "client/Api/Documents/SharePoint/common";
import { calculate } from "../documentOpenPossibilities";
import { ensureNotNil } from "client/Misc/utils";
import { SharePointDocumentActionContext } from "client/Features/Documents/SharePoint/actions";
import { openImageDialog } from "client/Features/Documents/Dialogs/ImagePreview/SharePointImagePubSubWrapper";

function execute(
	document: DocumentItemViewModel,
	allDocuments: readonly DocumentItemViewModel[],
	onSelectItem?: (item: DocumentItemViewModel) => void,
	context?: SharePointDocumentActionContext
) {
	if (document.itemType !== DocumentItemType.File || !calculate(document).canBeOpenedInImagePreviewDialog) {
		throw new Error("Must be executed with an image file");
	}

	const allImages: FileViewModel[] = [];

	for (const document of allDocuments) {
		if (document.itemType === DocumentItemType.File && calculate(document).canBeOpenedInImagePreviewDialog) {
			allImages.push(document);
		}
	}

	openImageDialog({
		initialImage: document,
		allImageItems: allImages,
		currentImageChangedCallback: (selectedImage: FileViewModel) => {
			const document: DocumentItemViewModel | undefined = allDocuments
				.find(d => d.id === selectedImage.id);

			onSelectItem?.(
				ensureNotNil(document)
			);
		},
		initialContext: context
	});
}

const previewImageInDialogAction = {
	execute
};

export { previewImageInDialogAction };
